import React from "react";
import "./inicio.css";
import InicioImage from "../../../media/inicio.svg";
import BienvenidoImage from "../../../media/inicio2.svg";

import HeaderVwLogo from "../../../ComponentsNav/Header/media/logo_vwm.svg";

class Inicio extends React.Component {
  render() {
    return (
      <div>
        <div
          className={
            "header_background text-center title_container text__center--vw"
          }
        >
          {<img src={HeaderVwLogo} className="mt-3" alt="VW Logo"></img>}
        </div>
        <div className="body_inicio color_background center container__font--vw">
          <div className="row">
            <div className="offset-2">
              <img className="imageInicio" src={InicioImage} alt="inicio"></img>
            </div>
            <div className="card-body-inicio col-2">
              <span className="text_center subtitulo">Bienvenido</span>
              <img
                className="imageBienvenido"
                src={BienvenidoImage}
                alt="inicio"
              ></img>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Inicio;
